import { useStore } from "@state/store"
import { useEffect } from "react"
import styled from "styled-components/macro"
import gsap from "gsap"
import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/navigation"
import "swiper/css/pagination"
import InfoCarousel from "./InfoCarousel"

const First = ({ info1Data, imageClick }) => {
  const contentControls = useStore((s) => s.contentControls)

  useEffect(() => {
    if (!contentControls) return
    gsap.to(".firstWrapper", {
      autoAlpha: contentControls.index === 0 ? 1 : 0,
      duration: 0.6,
      ease: "power3.inOut",
    })
  }, [contentControls])

  return (
    <FirstWrapper className="firstWrapper">
      <InfoCarousel info1Data={info1Data} imageClick={imageClick} />
    </FirstWrapper>
  )
}

export default First

const FirstWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: var(--primary);
`
